module.exports = __webpack_public_path__ + "img/gungroup-video-image.ba93a698.jpg";